// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Vd4TV","container":"styles_container__1fYnK","title":"styles_title__kjt41","wrapper":"styles_wrapper__3-qYM","answer":"styles_answer__20U2D"};